import { render, staticRenderFns } from "./nourishmentList.vue?vue&type=template&id=53aa7e2c&scoped=true&"
import script from "./nourishmentList.vue?vue&type=script&lang=js&"
export * from "./nourishmentList.vue?vue&type=script&lang=js&"
import style0 from "./nourishmentList.vue?vue&type=style&index=0&id=53aa7e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa7e2c",
  null
  
)

export default component.exports